<template>
    <footer class="container-fluid">
        <div id="switcher" class="notification is-primary">
            <div class="buttons is-centered">
                <b-button
                    :icon-pack="pack"
                    icon-left="baby"
                    type="is-primary"
                    tag="router-link"
                    to="/"
                    inverted
                    outlined
                    size="is-large"
                    class="mr-5"
                ></b-button>
                <b-button
                    :icon-pack="pack"
                    icon-left="book"
                    type="is-primary"
                    tag="router-link"
                    to="/log"
                    inverted
                    outlined
                    size="is-large"
                    class="mr-5"
                ></b-button>
                <b-button
                    :icon-pack="pack"
                    icon-left="chart-line"
                    type="is-primary"
                    tag="router-link"
                    to="/stats"
                    inverted
                    outlined
                    size="is-large"
                ></b-button>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            pack: "fa"
        }
    }
}
</script>

<style>
#switcher {
  position: relative;
  bottom: 0;
  width: 100%;
}
</style>